import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {PageHelper, PageService, Site, SiteService} from '../../common/services';
import {Observable} from 'rxjs';
import {PubSubService} from '../../common/services/pub-sub.service';
import {SubSink} from '@Common/core/utils/subsink';
import {finalize} from 'rxjs/operators';
import {BdcService} from '../../bdc.service';

@Component({
  selector: 'p8-bdc-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit, OnDestroy {
  sites$: Observable<Site[]>;
  arbo: null;
  order: any = [];
  subSink = new SubSink();

  constructor(
    private activatedRoute: ActivatedRoute,
    private pageHelper: PageHelper,
    private router: Router,
    private bdcService: BdcService,
    private pubsubService: PubSubService,
    private pageService: PageService,
    private siteService: SiteService,
    private pubSubSvc: PubSubService,
  ) {
  }

  ngOnInit() {
    this.loadSites();
  }

  loadSites() {
    this.pubSubSvc.publish('loading', true);
    this.sites$ = this.siteService
      .list(0, 0, '')
      .pipe(
        finalize(() => this.pubSubSvc.publish('loading', false))
      );
  }

  /**
   * Copie des children des pages du site
   * @param site
   */
  getPagesChildren(site: Site) {
    return [...site.pages.children];
  }

  editOrRemovePage(site, event) {
    if (event.action === 'edit') {
      this.editPage(event.id);
    } else if (event.action === 'move') {
      this.movePage(event);
    } else if (event.action === 'delete') {
      this.deletePage(site, event);
    }
  }

  movePage(event) {
    this.subSink.sink = this.bdcService.move(event.nodeId, event.parentId).subscribe();
  }

  deletePage(site, event) {
    this.subSink.sink = this.bdcService.delete(event.id).subscribe();
  }

  editPage(nodeId) {
    this.router.navigate([nodeId, 'edit'], {relativeTo: this.activatedRoute});
  }

  getArbo(arbo): void {
    this.arbo = arbo;
    this.saveOrder();
  }

  saveOrder(): void {
    this.orderMapping(this.arbo);
    this.subSink.sink = this.pageService.savePageOrder(this.order).subscribe();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  private orderMapping(data) {
    return Object.keys(data).reduce<any>((accumulator, key) => {
      const tab = {'id': data[key]['item']['id'], 'order': Number(key) + 1};
      this.order.push(tab);
      if (data[key]['children']) {
        this.orderMapping(data[key]['children']);
      }
      return accumulator.concat(this.order);
    }, []);
  }
}
